// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sv_a bhl_b bhl_bj","StrollerbaseBanner__hint":"sv_b bhl_vh","StrollerbaseBanner__link":"sv_c"};